"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.activeScheduledPromotion = activeScheduledPromotion;
exports.apiPromotionFromScheduled = apiPromotionFromScheduled;
/** The scheduled offer running at `nowMs`, if any. Windows are half-open. */
function activeScheduledPromotion(promotions, nowMs) {
    for (const promotion of promotions !== null && promotions !== void 0 ? promotions : []) {
        const startsAt = Date.parse(promotion.startsAt);
        const endsAt = Date.parse(promotion.endsAt);
        if (Number.isNaN(startsAt) || Number.isNaN(endsAt))
            continue;
        if (startsAt <= nowMs && nowMs < endsAt)
            return promotion;
    }
    return null;
}
function apiPromotionFromScheduled(promotion) {
    var _a, _b, _c;
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ id: promotion.id, name: promotion.name, bannerText: promotion.bannerText, discountCode: promotion.discountCode, discountValue: promotion.discountValue, discountType: promotion.discountType }, (promotion.shopifyId ? { shopifyId: promotion.shopifyId } : {})), { combinesWithOrderDiscounts: (_a = promotion.combinesWithOrderDiscounts) !== null && _a !== void 0 ? _a : false, combinesWithProductDiscounts: (_b = promotion.combinesWithProductDiscounts) !== null && _b !== void 0 ? _b : false, combinesWithShippingDiscounts: (_c = promotion.combinesWithShippingDiscounts) !== null && _c !== void 0 ? _c : false }), (promotion.isOrderLevel != null
        ? { isOrderLevel: promotion.isOrderLevel }
        : {})), (promotion.productScope != null
        ? { productScope: promotion.productScope }
        : {})), (promotion.eligibleShopifyProductIds != null
        ? {
            eligibleShopifyProductIds: promotion.eligibleShopifyProductIds,
        }
        : {}));
}
